import { useContext } from "react";
import { MyContext } from "../App";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";


const data = [{
    id: 1,
    question: {
        Eng: "Where are you from?",
        Fr: "D'où êtes-vous?",
        Ar: "من أين أنت؟"
    },
    Answer: {
        Eng: "We are based in Morocco, specifically in Ait Melloul, located in the Souss Massa region. However, we serve clients globally and are accessible via various communication channels regardless of your location.",
        Fr: "Nous sommes basés au Maroc, plus précisément à Ait Melloul, situé dans la région de Souss Massa. Cependant, nous servons des clients du monde entier et sommes accessibles via différents canaux de communication, peu importe votre localisation.",
        Ar: "نحن مقرنا في المغرب، تحديداً في آيت ملول، الموجودة في منطقة سوس ماسة. ومع ذلك، نحن نخدم عملائنا على مستوى العالم ونحن متاحون عبر مختلف قنوات الاتصال بغض النظر عن موقعك"
    }
},
{
    id: 2,
    question: {
        Eng: "What is your hourly rate?",
        Fr: "Quel est votre taux horaire ?",
        Ar: "ما هو سعرك بالساعة؟"
    },
    Answer: {
        Eng: "My hourly rate depends on the scope and complexity of the project. I offer competitive rates that reflect the quality of my work and the value I provide to clients. I strive to ensure that my pricing is fair and transparent, and I'm always open to discussing rates and negotiating based on your specific needs and budget constraints.",
        Fr: "Mon taux horaire dépend de l'ampleur et de la complexité du projet. Je propose des tarifs compétitifs qui reflètent la qualité de mon travail et la valeur que je fournis aux clients. Je m'efforce de garantir que mes tarifs sont justes et transparents, et je suis toujours ouvert à discuter des tarifs et à négocier en fonction de vos besoins spécifiques et de vos contraintes budgétaires.",
        Ar: "يعتمد سعري بالساعة على نطاق وتعقيد المشروع. أقدم أسعارًا تنافسية تعكس جودة عملي والقيمة التي أقدمها للعملاء. أسعى لضمان أن تكون تسعيرتي عادلة وشفافة، وأنا دائما متاح لمناقشة الأسعار والتفاوض بناءً على احتياجاتك المحددة والقيود الميزانية الخاصة بك"
    }
},
{
    id: 3,
    question: {
        Eng: "How long does it take to complete a project?",
        Fr: "Combien de temps faut-il pour terminer un projet?",
        Ar: "كم يستغرق إكمال مشروع؟"
    },
    Answer: {
        Eng: "The timeline for completing a project depends on various factors such as the scope of work, complexity, and client feedback. We strive to deliver high-quality results in a timely manner and work diligently to meet agreed-upon deadlines.",
        Fr: "Le délai de réalisation d'un projet dépend de différents facteurs tels que l'ampleur du travail, la complexité et les retours des clients. Nous nous efforçons de fournir des résultats de haute qualité dans les délais convenus et travaillons avec diligence pour respecter les délais fixés.",
        Ar: "يعتمد الجدول الزمني لإكمال مشروع على عوامل مختلفة مثل نطاق العمل والتعقيد وتغذية العميل. نحن نسعى جاهدين لتقديم نتائج عالية الجودة في الوقت المناسب ونعمل بجد للوفاء بالمواعيد النهائية المتفق عليها"
    }
},
{
    id: 4,
    question: {
        Eng: "Are you married?",
        Fr: "Êtes-vous marié(e) ?",
        Ar: "هل أنت متزوج؟"
    },
    Answer: {
        Eng: "No, I am not married. I am fully dedicated to my work and committed to providing the best service to my clients.",
        Fr: "Non, je ne suis pas marié(e). Je suis entièrement dédié(e) à mon travail et engagé(e) à fournir le meilleur service à mes clients.",
        Ar: "لا، أنا لست متزوجًا. أنا ملتزم تمامًا بعملي وملتزم بتقديم أفضل خدمة لعملائي"
    }
},
{
    id: 5,
    question: {
        Eng: "How old are you?",
        Fr: "Quel âge avez-vous ?",
        Ar: "كم عمرك؟"
    },
    Answer: {
        Eng: "I am 23 years old. Despite my young age, I have gained valuable experience in my field and am passionate about delivering exceptional results to my clients.",
        Fr: "J'ai 23 ans. Malgré mon jeune âge, j'ai acquis une expérience précieuse dans mon domaine et je suis passionné(e) par la réalisation de résultats exceptionnels pour mes clients.",
        Ar: "عمري 23 سنة. على الرغم من صغر سني، لقد اكتسبت خبرة قيمة في مجالي وأنا متحمس لتقديم نتائج استثنائية لعملائي"
    }
}, {
    id: 6,
    question: {
        Eng: "Do you develop mobile apps too?",
        Fr: "Développez-vous aussi des applications mobiles ?",
        Ar: "هل تقوم أيضًا بتطوير تطبيقات الجوال؟"
    },
    Answer: {
        Eng: "Yes, I do develop mobile apps as well. While my expertise lies primarily in web development, I also have experience in mobile app development. However, I must note that I am not as experienced in mobile app development as I am in web development. Nevertheless, I can provide mobile app development services tailored to your needs and requirements.",
        Fr: "Oui, je développe également des applications mobiles. Bien que mon expertise réside principalement dans le développement web, j'ai aussi de l'expérience dans le développement d'applications mobiles. Cependant, je dois noter que je n'ai pas autant d'expérience dans le développement d'applications mobiles que dans le développement web. Néanmoins, je peux fournir des services de développement d'applications mobiles adaptés à vos besoins et exigences.",
        Ar: "نعم، أقوم أيضًا بتطوير تطبيقات الجوال. بينما تكمن خبرتي بشكل أساسي في تطوير الويب، لدي أيضًا خبرة في تطوير تطبيقات الجوال. ومع ذلك، يجب علي أن أشير إلى أنني ليس لدي الخبرة نفسها في تطوير تطبيقات الجوال كما لدي في تطوير الويب. ومع ذلك، يمكنني تقديم خدمات تطوير تطبيقات الجوال المصممة وفقًا لاحتياجاتك ومتطلباتك"
    }
}]

const Faq = () => {
    const { Lang } = useContext(MyContext);
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

    return (
        <div id='faq' ref={ref} className="py-12 px-6 md:px-20 bg-gradient-to-b from-black/95 to-black/95 border-t border-white/10" >
            <div className="flex flex-col items-center gap-4 md:gap-6">
                <motion.div initial={{ opacity: 0 }}
                    animate={inView ? { opacity: 1 } : { opacity: 0 }}
                    transition={{ delay: 0.3 }} className="w-max px-3 py-0.5 text-md text-center font-normal text-white/90 border border-white/90 rounded-full">
                    FAQs
                </motion.div>
                <motion.div initial={{ y: -40, opacity: 0 }}
                    animate={inView ? { y: 0, opacity: 1 } : { y: -40, opacity: 0 }}
                    transition={{ delay: 0.4 }} className="text-3xl md:text-5xl text-center font-bold text-white max-w-md">
                    {Lang === 'Ar' ? 'الأسئلة المتكررة' : (Lang === 'Fr' ? 'Questions Fréquemment Posées' : 'Frequently Asked Questions')}
                </motion.div>

                <div className="py-8">
                    <motion.div initial={{ opacity: 0 }}
                        animate={inView ? { opacity: 1 } : { opacity: 0 }}
                        transition={{ delay: 0.6 }} className="py-6 px-10 border border-white/90 rounded-2xl">
                        <div className="grid divide-y divide-white/30 mx-auto text-white/90 w-full md:w-[42em]">
                            {data.map((item, index) => (
                                <motion.div initial={{ x: -80, opacity: 0 }}
                                    animate={inView ? { x: 0, opacity: 1 } : { x: -80, opacity: 0 }}
                                    transition={{ delay: (0.8 + index) * 0.3 }} key={index} className="py-4">
                                    <details className="group" open={item.id === 1}>
                                        <summary className="flex justify-between items-center font-semibold list-none">
                                            {item.question[Lang]}
                                            <span className="transition group-open:hidden">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                </svg>
                                            </span>
                                            <span className="transition hidden group-open:block">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                </svg>

                                            </span>
                                        </summary>
                                        <p className="text-white/70 mt-3 group-open:animate-fadeIn text-sm font-normal">
                                            {item.Answer[Lang]}
                                        </p>
                                    </details>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </div>
    );
};

export default Faq;
